jQuery(document).ready(function($) {
  if($(".flip-catalogue").length > 0)
  {
    $(".flip-catalogue .owl-carousel").owlCarousel({
      navigation: true, // Show next and prev buttons
      slideSpeed: 2500,
      autoplaySpeed: 2500,
      paginationSpeed: 2500,
      items: 1,
      itemsDesktop: false,
      itemsDesktopSmall: false,
      itemsTablet: false,
      itemsMobile: false,
      loop: true,
      autoplay: true,
      autoplayHoverPause: true,
      responsive: {
        0: {
          items: 1,
          nav: false,
        },
        480: {
          items: 1,
          nav: false,
        },
        992: {
          items: 1,
          nav: false,
        },
        1000: {
          items: 1,
          nav: true,
          loop: false,
        },
      },
    });
  }
});